const categories = [
  { id: 1, name: "Exp/ Bills" },
  { id: 2, name: "Exp/ Groceries" },
  { id: 3, name: "Exp/ Eating out" },
  { id: 4, name: "Exp/ Cosmetics" },
  { id: 5, name: "Exp/ Health" },
  { id: 6, name: "Exp/ Cleaning" },
  { id: 7, name: "Exp/ Hobby" },
  { id: 8, name: "Exp/ Clothes" },
  { id: 9, name: "Exp/ Transport" },
  { id: 10, name: "Exp/ Knowledge" },
  { id: 11, name: "Exp/ Debt" },
  { id: 12, name: "Exp/ Other" },
  { id: 13, name: "Inc/ Salary" },
  { id: 14, name: "Inc/ Selling" },
  { id: 15, name: "Inc/ From people" },
  { id: 16, name: "Inc/ Savings" }
];

export default categories;
